import { render, staticRenderFns } from "./LockerDeliveryPersonDetails.vue?vue&type=template&id=48ea916a"
import script from "./LockerDeliveryPersonDetails.vue?vue&type=script&lang=js"
export * from "./LockerDeliveryPersonDetails.vue?vue&type=script&lang=js"
import style0 from "./LockerDeliveryPersonDetails.vue?vue&type=style&index=0&id=48ea916a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports